import { useState, useEffect } from 'react';
import { getPrice } from '../services/api';
import './TradePanel.css';

export default function TradePanel({ ticker, balance, holdings, onTrade }) {
  const [type, setType] = useState('buy');
  const [shares, setShares] = useState('');
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const data = await getPrice(ticker);
        setPrice(data.price || 0);
      } catch {
        setPrice(0);
      }
    };
    fetchPrice();
  }, [ticker]);

  const sharesNum = parseInt(shares, 10) || 0;
  const total = sharesNum * price;
  const holding = holdings.find((h) => h.ticker === ticker);
  const maxBuyShares = price > 0 ? Math.floor(balance / price) : 0;
  const maxSellShares = holding?.shares || 0;

  const handleTrade = async () => {
    if (sharesNum <= 0 || price <= 0) return;
    setLoading(true);
    setMessage(null);
    const result = await onTrade(ticker, sharesNum, price, type);
    if (result.error) {
      setMessage({ type: 'error', text: result.error });
    } else {
      setMessage({ type: 'success', text: `${type === 'buy' ? 'Bought' : 'Sold'} ${sharesNum} shares of ${ticker}` });
      setShares('');
    }
    setLoading(false);
  };

  return (
    <div className="trade-panel">
      <div className="trade-tabs">
        <button className={type === 'buy' ? 'active buy' : ''} onClick={() => setType('buy')}>Buy</button>
        <button className={type === 'sell' ? 'active sell' : ''} onClick={() => setType('sell')}>Sell</button>
      </div>

      <div className="trade-body">
        <div className="trade-row">
          <label>Market Price</label>
          <span className="trade-price">${price.toFixed(2)}</span>
        </div>

        <div className="trade-row">
          <label>Shares</label>
          <input
            type="number"
            min="1"
            max={type === 'buy' ? maxBuyShares : maxSellShares}
            value={shares}
            onChange={(e) => setShares(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="trade-row">
          <label>Estimated Total</label>
          <span className="trade-total">${total.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
        </div>

        <div className="trade-info">
          {type === 'buy'
            ? `Available: $${balance.toFixed(2)} (max ${maxBuyShares} shares)`
            : `Holdings: ${maxSellShares} shares`}
        </div>

        {message && (
          <div className={`trade-message ${message.type}`}>{message.text}</div>
        )}

        <button
          className={`btn-trade ${type}`}
          onClick={handleTrade}
          disabled={loading || sharesNum <= 0 || (type === 'buy' && total > balance) || (type === 'sell' && sharesNum > maxSellShares)}
        >
          {loading ? 'Processing...' : `${type === 'buy' ? 'Buy' : 'Sell'} ${ticker}`}
        </button>
      </div>
    </div>
  );
}
